export default "__VITE_ASSET__BKh9mEOz__"